export const GET_CAMPAIGN_DATA = 'campaign/GET_CAMPAIGN_DATA';
export const GET_CAMPAIGN_SUCCESS = 'campaign/GET_CAMPAIGN_SUCCESS';
export const GET_CAMPAIGN_FAIL = 'campaign/GET_CAMPAIGN_FAIL';
export const CLEAR_CAMPAIGN_DATA = 'campaign/CLEAR_CAMPAIGN_DATA';
export const SET_QUERY_PARAMS = 'campaign/SET_QUERY_PARAMS';
